import React from "react";
import { useParams, useNavigate } from "react-router-dom";
import APIService from "../../Service/APIService";
import GenericDashboard from "../GenericDashboard/GenericDashboard";
import { Select, Button, Input, Modal, Row, Col } from "antd";
import { Link } from "react-router-dom";
import CustomHeader from "../CustomHeader/CustomHeader";
import "./IVRCss.css";
import { CheckOutlined, SearchOutlined, PlusOutlined } from "@ant-design/icons";
import Swal from "sweetalert2";
import TextInput from "../../common/text-input/index.js";
import { saveAs } from "file-saver";
import { colors } from "../../theme/colors";
import { useAuth } from '../AuthProvider.js';
import { createIVRSubmissionPdfBlob } from "./IVRSubmissionPdf";

const IVRManufacturers = (props) => {
  const { user } = useAuth();
  const userData = user;
  const params = useParams();
  const [ivrData, setIvrData] = React.useState(null);
  const [manufacturerData, setManufacturerData] = React.useState(null);
  const [isEditable, setIsEditable] = React.useState(false);
  const [IVRASStatus, setIVRASStatus] = React.useState(null);

  var JSZip = require("jszip");

  const getIVRASData = async () => {
    const apiService = new APIService();
    const response = await apiService.getDataFromBackend(
      `getivrmanufacturers?ivrID=${params?.id}`
    );
    console.log("response:", response);
    return response?.data?.data;
  };

  const downloadAll = async () => {
    console.log("Download All");
    const apiServe = new APIService();
    let zip = new JSZip();

    try {
      const secureZipResponse = await apiServe.downloadIvrSecureFilesZip(
        ivrData?.ID || params?.id
      );
      if (secureZipResponse?.data) {
        zip = await JSZip.loadAsync(secureZipResponse.data);
      }
    } catch (error) {
      const status = error?.response?.status;
      if (status !== 404) {
        throw error;
      }
    }

    const generatedPDF = await handleBlob();
    zip.file("IVRSubmission.pdf", generatedPDF);
    const blob = await zip.generateAsync({ type: "blob" });
    saveAs(blob, "files.zip");
  };

  const handleSubmit = async () => {
    // console.log("selectedManufacturer: ", selectedManufacturer);
    const postObj = {
      ID: params.id,
      IVRASStatus: IVRASStatus,
    };
    Swal.fire({
      title: "Are you sure?",
      text: "You want to update IVR Status?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, submit it!",
    }).then(async (result) => {
      if (result.isConfirmed) {
        const apiServe = new APIService();
        const response = await apiServe.updateDataToBackend(
          postObj,
          "updateivr?type=Status"
        );
        console.log("Update IVR Manufacturer Response: ", response);
        if (response?.status === 200 || response?.status === 201) {
          Swal.fire("Updated!", "IVR status has been updated.", "success").then(
            () => {
              window.location.reload();
            }
          );
        } else {
          Swal.fire("Error!", "Error in updating IVR status.", "error");
        }
      }
    });
  };

  const handleButtonClick = () => {
    if (isEditable) {
      handleSubmit(); // Trigger form submission
    } else {
      setIsEditable(true); // Enable edit mode
    }
  };
  const navigate = useNavigate();
  React.useEffect(() => {
    console.log("IVR Submissions");
    console.log("IVR ID ", params.id);
    if(userData?.Type === "Account" && !userData?.EnableIVR) {
      navigate('/');
    }
    // if(userData?.Type === "Manufacturer") {
    //   navigate('/');
    // }
    getIVRASData().then((data) => {
      if(data?.IVR == null) {
        navigate('/');
        return;
      }
      console.log("IVRAS: ", data);
      setIVRASStatus(data.IVR.IVRASStatus);
      setIvrData(data.IVR);
      let tempData = data.IVRManufacturers;
      tempData.map((ele) => {
        // ele["DownloadLink"] = <a download={ele.FileName} href={`data:application/pdf;base64,${ele.base64String}`}>Download</a>;
      });
      setManufacturerData(data.IVRManufacturers);
    });
  }, []);

  const [openDownloadModal, setOpenDownloadModal] = React.useState(false);
  const [openDeleteModal, setOpenDeleteModal] = React.useState(false);

  const handleOkDelete = async () => {
    console.log("Clicked OK");
    try {
      await downloadAll();
      const postObj = {
        ID: ivrData.ID,
        DeletedBy: userData.FirstName + " " + userData.LastName,
        DeletedByUserId: userData.UserID,
      };
      const apiServer = new APIService();
      const response = await apiServer.updateDataToBackend(
        postObj,
        `updateivr?type=Delete`
      );
      console.log("Response: ", response);
      if (response?.status === 200 || response?.status === 201) {
        Swal.fire({
          icon: "success",
          title: "Deleted Successfully",
          text: "IVR Form Submission has been deleted successfully",
        }).then(() => {
          window.location.reload();
        });
      } else {
        Swal.fire({
          icon: "error",
          title: "Error",
          text: "An error has occurred",
        });
      }
    } catch (error) {
      const serverMessage =
        error?.response?.data?.message ||
        "Failed to delete the IVR submission. The IVR was kept unchanged.";
      Swal.fire({
        icon: "error",
        title: "Delete Failed",
        text: serverMessage,
      });
    } finally {
      setOpenDeleteModal(false);
    }
  };

  const handleCancelDelete = () => {
    console.log("Clicked Cancel");
    setOpenDeleteModal(false);
  };

  const handleBlob = async () => {
    const blob = await createIVRSubmissionPdfBlob(ivrData);
    console.log("Blob: ", blob);
    return blob;
  };

  return (
    <div>
      {ivrData && (
        <>
          <CustomHeader
            leftTopText={`${ivrData.AccountName}`}
            leftBottomText="IVRAS ID"
            leftBottomExtraText={ivrData.IVRASID}
            rightTopText="Logged in as Admin"
            rightBottomText="User"
          />
          <div style={{ display: "flex" }}>
            {/* <Button type="primary" onClick={() => setOpenDownloadModal(true)} icon={<CheckOutlined />} iconPosition="start" style={{ background: '#27a907', marginRight: '16px' }}>Download PDF</Button> */}
            {userData?.Type === "Admin" && (
              <Button
                type="primary"
                style={{
                  marginRight: "16px",
                  background: isEditable ? "#27a907" : "#ff9202",
                }}
                onClick={() => handleButtonClick()}
              >
                {isEditable ? "Save Changes" : "Edit"}
              </Button>
            )}

            {ivrData.IsDeleted === false && userData?.Type === "Admin" && (
              <>
                {/* <Button type="primary" onClick={() => downloadPDF()} icon={<CheckOutlined />} iconPosition="start" style={{ background: '#27a907', marginRight: '16px' }}>Download PDF</Button> */}
                {/* <Button type="primary" onClick={handleDownload} icon={<CheckOutlined />} iconPosition="start" style={{ background: '#27a907', marginRight: '16px' }}>Download Attachments</Button> */}
                {/* <Button type="primary" onClick={downloadAll} icon={<CheckOutlined />} iconPosition="start" style={{ background: '#27a907', marginRight: '16px' }}>Download IVR Data</Button>
                <Button type="primary" onClick={() => setOpenDeleteModal(true)} style={{ background: '#ff0000' }}>Delete From Submission</Button> */}
                <Button
                  type="primary"
                  onClick={() => setOpenDeleteModal(true)}
                  style={{ background: "#ff0000" }}
                >
                  Download & Delete
                </Button>
              </>
            )}
            {ivrData.IsDeleted === true && (
              <>
                <br />
                <p>Form data has been deleted.</p>
              </>
            )}
          </div>
          {ivrData && (
            <div>
              <label className="form-label">Status</label>
              <Select
                style={{ width: 120 }}
                // defaultValue={{ labe: ivrData.IVRASStatus, value: ivrData.IVRASStatus }}
                value={{ label: IVRASStatus, value: IVRASStatus }}
                options={[
                  { label: "Submitted", value: "Submitted" },
                  // { label: 'Pending', value: 'Pending' }
                ]}
                disabled={!isEditable}
                onChange={(value) => setIVRASStatus(value)}
              />
              <p className="input-subtitle">
                This status indicates whether the submission was sent to the
                Manufacturer
              </p>
            </div>
          )}
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              margin: "20px 0px 10px 0px",
            }}
          >
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                gap: "20px",
              }}
            >
              {/* <Button icon={<PlusOutlined />} iconPosition='end' ghost style={{ color: '#444', borderColor: '#444' }}>Add Filter</Button> */}
            </div>

            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                gap: "10px",
              }}
            >
              <Input
                placeholder="Search"
                suffix={<SearchOutlined />}
                style={{ height: "36px" }}
              />
              {userData?.Type === "Admin" && (
                <Button
                  type="primary"
                  style={{
                    marginBottom: 16,
                    background: colors["primaryColor"],
                  }}
                  icon={<PlusOutlined />}
                  iconPosition="start"
                >
                  <Link
                    to={`/AddIVRManufacturer/${ivrData.ID}`}
                    onClick={() => console.log(true)}
                  >
                    New
                  </Link>
                </Button>
              )}
            </div>
          </div>
          <GenericDashboard data={manufacturerData} screen="IVRManufacturers" />
          <Modal
            title="Are you sure you want to delete form submission?"
            open={openDeleteModal}
            onOk={handleOkDelete}
            onCancel={handleCancelDelete}
            centered={true}
            footer={false}
          >
            <p>
              This action will delete all the data from this IVR form
              submission, except for the following:
            </p>
            <ul>
              <li style={{ listStyleType: "disc" }}>IVRAS ID</li>
              <li style={{ listStyleType: "disc" }}>Form Submission Date</li>
              <li style={{ listStyleType: "disc" }}>Account Name</li>
              <li style={{ listStyleType: "disc" }}>Place of Service</li>
              <li style={{ listStyleType: "disc" }}>City</li>
              <li style={{ listStyleType: "disc" }}>State</li>
              <li style={{ listStyleType: "disc" }}>Zip</li>
              <li style={{ listStyleType: "disc" }}>
                Medicare Admin Contractor
              </li>
              <li style={{ listStyleType: "disc" }}>Patient DOB</li>
              <li style={{ listStyleType: "disc" }}>
                All fields pertaining to Primary Insurance
              </li>
              <li style={{ listStyleType: "disc" }}>
                All fields pertaining to Secondary Insurance
              </li>
              <li style={{ listStyleType: "disc" }}>Wound Type</li>
              <li style={{ listStyleType: "disc" }}>Wound Size</li>
              <li style={{ listStyleType: "disc" }}>Application CPT</li>
              <li style={{ listStyleType: "disc" }}>ICD-10 Diagnosis Code</li>
              <li style={{ listStyleType: "disc" }}>SNF</li>
              <li style={{ listStyleType: "disc" }}>Surgical Global Period</li>
              <li style={{ listStyleType: "disc" }}>CPT Codes</li>
            </ul>
            <p>
              You will no longer be able to download the PDF. This action cannot
              be undone.
            </p>
            <Button
              type="primary"
              onClick={handleOkDelete}
              style={{ background: "#ff0000" }}
            >
              Download & Delete
            </Button>
          </Modal>
        </>
      )}
    </div>
  );
};

export default IVRManufacturers;
